module.exports = "/_next/static/images/CsaBadge@2x-65ea75625e379d9b9eb80579d7957adb.png";